export default __webpack_public_path__ + "static/media/SatSource&Ownership.bf6e5497.gif";